var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#FF3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 4.155V8.445C10.6 8.9 10.5775 9.3475 10.5325 9.7875C10.4875 10.2225 10.4275 10.685 10.3525 11.175H9.1C9.025 10.685 8.965 10.2225 8.92 9.7875C8.875 9.3475 8.8525 8.9 8.8525 8.445V4.155H10.6ZM8.5675 13.98C8.5675 13.825 8.595 13.6775 8.65 13.5375C8.71 13.3975 8.79 13.2775 8.89 13.1775C8.995 13.0775 9.1175 12.9975 9.2575 12.9375C9.3975 12.8775 9.5475 12.8475 9.7075 12.8475C9.8625 12.8475 10.01 12.8775 10.15 12.9375C10.29 12.9975 10.41 13.0775 10.51 13.1775C10.61 13.2775 10.69 13.3975 10.75 13.5375C10.81 13.6775 10.84 13.825 10.84 13.98C10.84 14.14 10.81 14.29 10.75 14.43C10.69 14.565 10.61 14.6825 10.51 14.7825C10.41 14.8825 10.29 14.96 10.15 15.015C10.01 15.075 9.8625 15.105 9.7075 15.105C9.5475 15.105 9.3975 15.075 9.2575 15.015C9.1175 14.96 8.995 14.8825 8.89 14.7825C8.79 14.6825 8.71 14.565 8.65 14.43C8.595 14.29 8.5675 14.14 8.5675 13.98Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/redWarning.c8c317996fd2ff7e3be4cf4332e0efc4.svg";
export { ForwardRef as ReactComponent };